import Button from '@material-ui/core/Button'
import React, { Component } from 'react'
import { deviceType, isMobile, isTablet } from 'react-device-detect'
import WebFooter from '../../source/WebScreen/WebFooter'
import './Login.css'
import styles from './LoginForm.module.css'

export class LoginOTPForm extends Component {
  constructor(props) {
    super(props)

    console.log(props.errorMesssage)
  }

  render() {
    return (
      <div>
        {deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false') ? (
          <div className="loginformnew">
            <div className={styles.loginform_flex_container}>
              {/* Left Panel: Image and Footer */}
              <div className={styles.loginform_left_panel}>
                <div className={styles.loginform_image_wrapper}>
                  <img src={require('../../source/Images/Banner/welcome_image_desktop.jpg')} className={styles.loginform_main_image} alt="welcome" />
                </div>
                <div className={styles.loginform_footer}>
                  Copyright © 2019-2026 Universal Health Fellowship. All rights reserved. | Powered by CarynHealth<br />
                  Version 6.1.0
                </div>
              </div>
              {/* Right Panel: Form */}
              <div className={styles.loginform_right_panel}>
                <form onSubmit={this.props.confirmSignIn} className={styles.loginform_form_wrapper}>
                  <img src={require('../../source/Images/Banner/logo.png')} className={styles.login_uhs_logo} alt="logo" />
                  
                  <h4 className="label-head text-center" style={{ fontSize: '16px', fontWeight: '400', marginBottom: '20px', color: '#333', lineHeight: '1.5' }}>
                    We have delivered the authentication code by SMS to {this.props.user.challengeParam.CODE_DELIVERY_DESTINATION}. Please enter the code to complete authentication.
                  </h4>

                  {this.props.errorMesssage && this.props.errorMesssage.length > 0 && (
                    <div className={styles.login_error_message}>{this.props.errorMesssage}</div>
                  )}
                  
                  <div className={styles.login_input_container}>
                    <input
                      type="password"
                      name="verificationCode"
                      required
                      onChange={this.props.handleChange}
                      placeholder="Enter verification code"
                      className={["login_input_username", styles.loginform_input].join(' ')}
                    />

                    <Button type="submit" className={["login_button", styles.loginform_button].join(' ')} onClick={this.props.confirmSignIn}>
                      SIGN IN
                    </Button>
                  </div>

                  <div className="text-center" style={{ marginTop: '20px', fontSize: '14px' }}>
                    <span>Didn't receive?</span>{' '}
                    <span
                      className="mfa_resend_code"
                      onClick={() => {
                        this.props.handleSubmit()
                      }}
                      style={{ color: '#2a3fa7', cursor: 'pointer', textDecoration: 'underline', fontWeight: '500' }}
                    >
                      Resend Code
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ) : (
          <div class="loginmobile">
            <div class="loginmobile_header">
              {/* <MenuIcon style={{ color: '#ffffff', marginRight: '4vw',width:'8vw' }} /> */}
              <div class="loginmobile_header_text">Member Portal</div>
            </div>

            <div class="loginmobile_container">
              <form
                            >
                <div class="loginmobile_image_container">
                  <img src={require('../../source/Images/Banner/welcome_image_desktop.jpg')} class="loginmobile_banner" />
                  <img src={require('../../source/Images/Banner/logo.png')} class="loginmobile_logo" />
                </div>

                <h4 className="label-head text-center">
                  We have delivered the authentication code by SMS to
                  {this.props.user.challengeParam.CODE_DELIVERY_DESTINATION}. Please enter the code to complete authentication.
                </h4>

                <p className="a-errorMessage" hidden={this.props.errorMesssage.length <= 0}>
                  The code entered is invalid, please try again.
                </p>

                <div class="loginmobile_input_container">
                  {/* <p class="mobile_login_new_error_text" hidden={this.props.errorMsg.length <= 0}>{this.props.errorMsg}</p> */}
                  <div class="mobile-linput">
                    <input
                      type="password"
                      name="verificationCode"
                      required
                      onChange={this.props.handleChange}
                      class="loginmobile_input_username"
                      placeholder='Enter verification code'
                    />
                  </div>

                  <Button type="submit" variant="contained" color="" class="loginmobile_button mb-5" onClick={this.props.confirmSignIn}>
                    SIGN IN
                  </Button>
                </div>

                <div class="text-center">
                  <span>Didn't receive?</span>{' '}
                  <span
                    class="mfa_resend_code"
                    onClick={() => {
                      this.props.handleSubmit()
                    }}
                  >
                    Resend Code
                  </span>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default LoginOTPForm






